import { useMutation } from '@apollo/client';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

export const BEGINN_MASS_EDIT_BACKGROUND_JOB_MUTATION = gql`
  mutation BeginMassEditProjectBackgroundJob(
    $projectIds: [String!]!
    $modificationInput: ProjectInfoModificationInput!
  ) {
    beginMassEditProjectBackgroundJob(
      projectIds: $projectIds
      modificationInput: $modificationInput
    ) {
      jobId
      batchUri
    }
  }
`;

export const useMassEditBackgroundJob = ({ projectIds, setBatchState }) => {
  const [massEditBackgroundJob] = useMutation(
    BEGINN_MASS_EDIT_BACKGROUND_JOB_MUTATION
  );

  return useCallback(
    async input => {
      setBatchState({
        batchId: null,
        batchInProgress: true
      });
      const { data, error } = await massEditBackgroundJob({
        variables: {
          projectIds,
          modificationInput: input
        }
      });

      const { batchUri } = data?.beginMassEditProjectBackgroundJob;

      setBatchState({
        batchId: batchUri,
        batchInProgress: !error
      });
    },
    [setBatchState, massEditBackgroundJob, projectIds]
  );
};

export default useMassEditBackgroundJob;
